import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../../services/api';
import { getCurrentUser } from '../../utils/auth';

const TOAST_HIDE_MS = 5000;


const Dashboard = () => {
  // ...原有state...
  const [showOrderToast, setShowOrderToast] = useState(false);
  const currentUser = getCurrentUser();

  const [stats, setStats] = useState({
    totalUsers: 0,
    totalActivities: 0,
    totalRegistrations: 0,
    activeActivities: 0
  });
  const [shopProductsCount, setShopProductsCount] = useState(0);
  const [shopOrdersCount, setShopOrdersCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // toast自动隐藏逻辑
  useEffect(() => {
    if (shopOrdersCount > 0 && (getCurrentUser()?.role === 'admin' || getCurrentUser()?.role === 'union')) {
      setShowOrderToast(true);
      const timer = setTimeout(() => setShowOrderToast(false), TOAST_HIDE_MS);
      return () => clearTimeout(timer);
    }
  }, [shopOrdersCount]);

  // fetchShopStats函数（组件体内定义）
  const fetchShopStats = async () => {
    try {
      // 商品数量
      const productsRes = await apiService.getShopProducts();
      setShopProductsCount(Array.isArray(productsRes.data) ? productsRes.data.filter(p => p.status !== 'disabled' && p.stock > 0).length : 0);
    } catch (e) {
      setShopProductsCount(0);
    }
    try {
      // 订单数量（需要发货）
      const pendingRes = await apiService.getPendingOrdersCount();
      setShopOrdersCount(typeof pendingRes.data?.pending_count === 'number' ? pendingRes.data.pending_count : 0);
    } catch (e) {
      setShopOrdersCount(0);
    }
  };

  // fetchStats函数（组件体内定义）
  const fetchStats = async () => {
    try {
      setLoading(true);
      // 获取用户列表
      const usersResponse = await apiService.getUsers();
      // 获取活动列表
      const activitiesResponse = await apiService.getActivities();
      // 获取活跃活动
      const activeActivitiesResponse = await apiService.getActiveActivities();
      // 获取用户活动列表
      const userActivitiesResponse = await apiService.getUserActivities();
      setStats({
        totalUsers: usersResponse.data.length,
        totalActivities: activitiesResponse.data.length,
        totalRegistrations: userActivitiesResponse.data.length,
        activeActivities: activeActivitiesResponse.data.length
      });
    } catch (err) {
      setError('获取统计数据失败');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // useEffect里只调用
  useEffect(() => {
    fetchShopStats();
    fetchStats();
  }, []);

  if (loading) {
    return (
      <div className="text-center my-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">加载中...</p>
      </div>
    );
  }

  // 已在顶部声明currentUser，这里无需重复声明
  return (
    <>
      {/* 悬浮Toast样式 */}
      {showOrderToast && (currentUser && (currentUser.role === 'admin' || currentUser.role === 'union')) && (
        <div style={{
          position: 'fixed',
          right: 24,
          bottom: 24,
          zIndex: 9999,
          minWidth: 320,
          maxWidth: 400,
          boxShadow: '0 8px 32px rgba(80,80,120,0.18)',
          borderRadius: 16,
          background: 'linear-gradient(135deg, #f7fafc 60%, #e0eaff 100%)',
          border: 'none',
          padding: 0
        }}>
          <div style={{ display: 'flex', alignItems: 'center', padding: '18px 18px 12px 18px' }}>
            <div style={{
              background: 'linear-gradient(135deg,#5f7cff 60%,#8adfff 100%)',
              borderRadius: '50%',
              width: 44,
              height: 44,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: 16,
              boxShadow: '0 2px 8px rgba(95,124,255,0.10)'
            }}>
              <i className="bi bi-bag-check-fill" style={{ fontSize: 24, color: '#fff' }}></i>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 18, fontWeight: 600, color: '#313a4e' }}>
                <span style={{ fontSize: 24, color: '#3a6cff', fontWeight: 700 }}>{shopOrdersCount}</span>
                <span style={{ marginLeft: 8 }}>待处理订单</span>
              </div>
              <div style={{ fontSize: 13, color: '#6c7a99', marginTop: 2 }}>请及时处理商城订单</div>
            </div>
            <button
              type="button"
              className="btn-close ms-2"
              aria-label="Close"
              onClick={() => setShowOrderToast(false)}
              style={{ filter: 'invert(0.5)', opacity: 0.6, transition: 'opacity 0.2s' }}
              onMouseOver={e => e.currentTarget.style.opacity = 1}
              onMouseOut={e => e.currentTarget.style.opacity = 0.6}
            ></button>
          </div>
          <div style={{ padding: '0 18px 16px 78px', marginTop: -8 }}>
            <Link
              to="/admin/shop-orders"
              className="btn btn-outline-primary btn-sm"
              style={{ borderRadius: 20, fontWeight: 500, padding: '4px 18px' }}
            >
              立即前往
            </Link>
          </div>
        </div>
      )}

      <h2 className="mb-4">管理员控制面板</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="row mb-4">
        <div className="col-md-3">
         <div className="card" style={{background:'#FF6B6B',color:'#fff'}}>
            <div className="card-body text-center">
              <h5 className="card-title">活动总数</h5>
              <h2 className="display-4">{stats.totalActivities}</h2>
              <Link to="/admin/activities" className="btn btn-outline-light mt-2">管理活动</Link>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card" style={{background:'#FFD93D',color:'#fff'}}>
            <div className="card-body text-center">
              <h5 className="card-title">报名总数</h5>
              <h2 className="display-4">{stats.totalRegistrations}</h2>
              <Link to="/admin/user-activities" className="btn btn-outline-light mt-2">管理报名</Link>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card" style={{background:'#6BCB77',color:'#fff'}}>
            <div className="card-body text-center">
              <h5 className="card-title">积分管理</h5>
              <h2 className="display-4"><i className="bi bi-award"></i></h2>
              <Link to="/admin/points" className="btn btn-outline-light mt-2">管理积分</Link>
            </div>
          </div>
        </div>
        <div className="col-md-3">
        <div className="card" style={{background:'#4D96FF',color:'#fff'}}>
            <div className="card-body text-center">
              <h5 className="card-title">积分操作日志</h5>
              <h2 className="display-4"><i className="bi bi-journal-text"></i></h2>
              <Link to="/admin/points-logs" className="btn btn-outline-light mt-2">查看日志</Link>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-4">

        <div className="col-md-3">
        <div className="card" style={{background:'#FF6F91',color:'#fff'}}>
            <div className="card-body text-center">
              <h5 className="card-title">商城管理</h5>
              <h2 className="display-4">{shopProductsCount}</h2>
              <Link to="/admin/shop" className="btn btn-outline-light mt-2">管理商品</Link>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card" style={{background:'#845EC2',color:'#fff'}}>
            <div className="card-body text-center">
              <h5 className="card-title">订单管理</h5>
              <h2 className="display-4">{shopOrdersCount}</h2>
              <Link to="/admin/shop-orders" className="btn btn-outline-light mt-2">管理订单</Link>
            </div>
          </div>
        </div>
        <div className="col-md-3">
        <div className="card" style={{background:'#FF9671',color:'#fff'}}>
            <div className="card-body text-center">
              <h5 className="card-title">用户总数</h5>
              <h2 className="display-4">{stats.totalUsers}</h2>
              <Link to="/admin/users" className="btn btn-outline-light mt-2">管理用户</Link>
            </div>
          </div>
        </div>
        <div className="col-md-3">
        <div className="card" style={{background:'#FFC75F',color:'#fff'}}>
            <div className="card-body text-center">
              <h5 className="card-title">系统设置</h5>
              <h2 className="display-4"><i className="bi bi-gear"></i></h2>
              <Link to="/admin/system-config" className="btn btn-outline-light mt-2">进入设置</Link>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-primary text-white">
              <h4 className="mb-0">快速操作</h4>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-4 mb-3">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">用户管理</h5>
                      <p className="card-text">管理系统用户，包括添加、编辑和删除用户。</p>
                      <Link to="/admin/users" className="btn btn-primary">进入</Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">活动管理</h5>
                      <p className="card-text">管理系统活动，包括创建、编辑和删除活动。</p>
                      <Link to="/admin/activities" className="btn btn-success">进入</Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">报名管理</h5>
                      <p className="card-text">管理用户活动报名，更新用户参与状态。</p>
                      <Link to="/admin/user-activities" className="btn btn-info">进入</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
